import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import MineralUiButton from 'mineral-ui/Button';
import Spinner from './Spinner';

// Refer to https://mineral-ui.com/components/button
// Additional props
const propTypes = {
  loading: PropTypes.bool,
  primary: PropTypes.bool,
  children: PropTypes.node,
};
const defaultProps = {
  loading: false,
  primary: undefined,
  children: undefined,
};

// Hide is used instead of hidden to prevent it being passed down
const HideableSpan = styled.span`
  visibility: ${props => (props.hide ? 'hidden' : 'inherit')};
`;

const RelativeButton = styled(MineralUiButton)({
  position: 'relative',
});

/* We wrap the content of a button with a span that can be hidden.
 * This way the button width is maintained when the spinner appears.
 * Eventually we need to implement our own button.
 */
export default function Button({
  children,
  loading,
  primary,
  ...rest
}) {
  let childrenMarkup;
  if (children || loading) {
    childrenMarkup = (
      <React.Fragment>
        <HideableSpan hide={loading}>{children}</HideableSpan>
        {loading ? <Spinner primary={primary} /> : undefined}
      </React.Fragment>
    );
  }

  return (
    <RelativeButton primary={primary} {...rest}>
      {childrenMarkup}
    </RelativeButton>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
